import {  CommonResponse, ContractorIdReq, WorkerDto, WorkerRequest } from "@gtpl/shared-models/masters";
import axios from "axios";
import connection from "./connection";


export class WorkerService{
    URL = connection.DEPLOY_URL + '/workers';

    async createWorker(req:WorkerDto): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createWorker',req)
            .then(res => {
                return res.data
            })
    }


    async updateWorker(req:WorkerDto):Promise<CommonResponse>{
        return await axios.post(this.URL + '/updateWorker',req)
        .then(res=>{
            return res.data
        })
    }

    
    async getAllworkerData():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllworkerData')
        .then(res=>{
            return res.data
        })
    }

    
    async getAllActiveworkerData():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllActiveworkerData')
        .then(res=>{
            return res.data
        })
    }

    
    async activateOrDeactivateworker(req:WorkerRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/activateOrDeactivateworker',req)
        .then(res=>{
            return res.data
        })
    }

    async getWorkersAgainstContractor(req:ContractorIdReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getWorkersAgainstContractor',req)
        .then(res=>{
            return res.data
        })
    }
}